import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PortalLayout from './PortalLayout';
import { PortalLogin, PortalRegister, PortalVerify, PortalForgot, PortalReset } from './AuthPages';
import { OverviewPage, ConnectionPage, TrafficPage, DevicesPage, ServicePage, AnnouncementsPage, ProfilePage, HelpPage, LeasedLineOnly } from './pages';
import { ComplaintPage, TicketsPage, TicketDetailPage } from './tickets';
import { BillingPage } from './billing';
import { OrdersPage, OrderDetailPage } from './orders';

export default function PortalApp() {
  return (
    <Routes>
      <Route path="login" element={<PortalLogin />} />
      <Route path="register" element={<PortalRegister />} />
      <Route path="verify" element={<PortalVerify />} />
      <Route path="activate" element={<PortalReset activate />} />
      <Route path="forgot-password" element={<PortalForgot />} />
      <Route path="reset-password" element={<PortalReset />} />
      <Route element={<PortalLayout />}>
        <Route index element={<OverviewPage />} />
        <Route path="connection" element={<ConnectionPage />} />
        <Route path="traffic" element={<LeasedLineOnly><TrafficPage /></LeasedLineOnly>} />
        <Route path="devices" element={<LeasedLineOnly><DevicesPage /></LeasedLineOnly>} />
        <Route path="service" element={<ServicePage />} />
        <Route path="billing" element={<BillingPage />} />
        <Route path="complaint" element={<ComplaintPage />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="orders/:orderId" element={<OrderDetailPage />} />
        <Route path="tickets" element={<TicketsPage />} />
        <Route path="tickets/:ticketId" element={<TicketDetailPage />} />
        <Route path="announcements" element={<AnnouncementsPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="help" element={<HelpPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/customer-portal" replace />} />
    </Routes>
  );
}
